import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Pencil, Trash2, Phone, Mail, HeartPulse } from "lucide-react";
import { sectionTag, sectionLabel } from "@/lib/sections";

export default function MemberCard({ member: m, overdueInfo, onEdit, onDelete }) {
  const medicalLine = [m.allergies, m.medical_info].filter(Boolean).join(" · ");
  return (
    <Card className="card-shadow-soft" data-testid={`member-card-${m.id}`}>
      <CardContent className="p-5 space-y-3">
        <div className="flex items-start justify-between gap-2">
          <div>
            <div className="font-bold text-lg leading-tight" style={{ fontFamily: "Outfit" }}>{m.full_name}</div>
            <span className={`scout-tag ${sectionTag(m.section)} mt-2`}>{sectionLabel(m.section)}</span>
          </div>
          <div className="flex gap-1">
            <Button size="icon" variant="ghost" onClick={() => onEdit(m)} data-testid={`edit-member-${m.id}`}>
              <Pencil className="w-4 h-4" />
            </Button>
            <Button size="icon" variant="ghost" onClick={() => onDelete(m.id)} data-testid={`delete-member-${m.id}`}>
              <Trash2 className="w-4 h-4 text-destructive" />
            </Button>
          </div>
        </div>
        <div className="text-sm text-muted-foreground space-y-1">
          {m.date_of_birth && <div>DOB: {m.date_of_birth}</div>}
          {m.parent_guardian && <div>Guardian: <span className="text-foreground">{m.parent_guardian}</span></div>}
          {m.phone && <div className="flex items-center gap-1.5"><Phone className="w-3 h-3" />{m.phone}</div>}
          {m.email && <div className="flex items-center gap-1.5 truncate"><Mail className="w-3 h-3" />{m.email}</div>}
          {medicalLine && (
            <div className="flex items-start gap-1.5 text-amber-700 dark:text-amber-400">
              <HeartPulse className="w-3 h-3 mt-0.5" />
              <span>{medicalLine}</span>
            </div>
          )}
        </div>
        <div className="flex items-center justify-between pt-2 border-t border-border text-xs">
          <span className="text-muted-foreground flex items-center gap-1.5">
            Fee: <span className="font-semibold text-foreground">€{Number(m.fee_amount).toFixed(2)} / {m.fee_frequency}</span>
            {overdueInfo?.overdue && (
              <span data-testid={`overdue-badge-${m.id}`} className="scout-tag bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300">
                Overdue · {overdueInfo.overdue_by}
              </span>
            )}
          </span>
          {m.uniform_size && <span className="text-muted-foreground">Uniform: {m.uniform_size}</span>}
        </div>
      </CardContent>
    </Card>
  );
}
